import cx from 'classnames';
import Button, { isButtonProps } from '../Button';
import CircularLoader from '../CircularLoader';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function LoadingButton({
  loading,
  className,
  children,
  ...props
}) {
  return /*#__PURE__*/_jsxs(Button, {
    ...props,
    ...(isButtonProps(props) ? {
      disabled: props.disabled || loading
    } : {}),
    className: cx('loading-button', className, {
      'loading-button--active': loading
    }),
    children: [loading ? /*#__PURE__*/_jsx(CircularLoader, {
      className: "loading-button__loader"
    }) : null, /*#__PURE__*/_jsx("span", {
      children: children
    })]
  });
}